import React from 'react';
import PageMeta from '../components/common/PageMeta';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import DigitalGoodsPage from "../pages/digital-goods/DigitalGoodsPage";
import Footer from "../components/Home/Footer";
import IntegrationOptions from "../pages/digital-goods/IntegrationOptions";
import Benefits from "../pages/digital-goods/Benefits";

const DigitalGoods = () => {
  return (
    <Layout>
      <PageMeta title='Sunlex' />
      <Navbar classOption='navbar-light' />
      <DigitalGoodsPage />
      <IntegrationOptions />
      <Benefits />
      <Footer />
    </Layout>
  );
};

export default DigitalGoods;
